/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType, INotifyPropertyChanged_$type, PropertyChangedEventArgs } from "igniteui-react-core";
import { ElevationHelper } from "igniteui-react-core";
import { AnimationKeyFrameEffect } from "igniteui-react-core";
import { AnimationKeyFrameEffectTiming } from "igniteui-react-core";
import { KeyFrameAnimationFactory } from "igniteui-react-core";
import { Rect } from "igniteui-react-core";
import { stringFormat } from "igniteui-react-core";
import { stringEmpty } from "igniteui-react-core";
import { OnClosedEventArgs } from "./OnClosedEventArgs";
import { List$1 } from "igniteui-react-core";
import { AnimationKeyFrameProperty } from "igniteui-react-core";
import { TranslateTransform } from "igniteui-react-core";
import { OnPopupEventArgs } from "./OnPopupEventArgs";
import { BrushUtil } from "igniteui-react-core";
/**
 * @hidden
 */
var PopupView = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PopupView, _super);
    function PopupView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.i = null;
        _this.c = null;
        _this.m = null;
        _this.l = null;
        _this.k = null;
        _this.p = null;
        _this.f = false;
        _this.e = true;
        return _this;
    }
    Object.defineProperty(PopupView.prototype, "d", {
        get: function () {
            return this.c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PopupView.prototype, "j", {
        get: function () {
            return this.i;
        },
        enumerable: true,
        configurable: true
    });
    PopupView.prototype.x = function () {
        this.m.setStyleProperty("height", "0%");
        this.m.setStyleProperty("width", "0%");
        this.l = this.i.createElement("div");
        this.l.setStyleProperty("position", "absolute");
        this.l.setStyleProperty("overflow", "hidden");
        this.l.setStyleProperty("z-index", "10000");
        this.l.setAttribute("key", "popupContentAreaOuter");
        this.k = this.i.createElement("div");
        this.k.setAttribute("key", "popupContentAreaInner");
        this.l.append(this.k);
    };
    PopupView.prototype.ab = function () {
        var a = this.d;
        var b = ElevationHelper.e(a.r, a.au, a.at, a.as);
        this.l.setStyleProperty("box-shadow", b);
    };
    PopupView.prototype.ac = function () {
        if (null == this.m) {
            return;
        }
        this.ab();
    };
    PopupView.prototype.q = function () {
        if (null != this.l) {
            this.ac();
            this.l.setStyleProperty("height", "0px");
            var a = this.l.getNativeElement();
            if (false == this.f) {
                document.body.appendChild(a);
                this.f = true;
                if (this.e) {
                    this.v();
                }
            }
        }
    };
    PopupView.prototype.z = function () {
        if (null != this.l && this.f) {
            var a = this.l.getNativeElement();
            document.body.removeChild(a);
            this.f = false;
        }
    };
    PopupView.prototype.r = function (a) {
        this.k.append(a);
    };
    PopupView.prototype.a = function (a) {
        return new AnimationKeyFrameEffect(0, this.k, 0, null, a);
    };
    PopupView.prototype.b = function (a) {
        return new AnimationKeyFrameEffect(0, this.l, 0, null, a);
    };
    PopupView.prototype.s = function () {
        if (KeyFrameAnimationFactory.h == null) {
            KeyFrameAnimationFactory.h = this.j;
        }
    };
    PopupView.prototype.n = function () {
        return this.k.outerHeight();
    };
    PopupView.prototype.o = function () {
        return this.k.outerWidth();
    };
    PopupView.prototype.g = function (a, b) {
        var c;
        var t1 = b;
        L0: while (true) {
            switch (t1) {
                case 0:
                case 1:
                    c = a.left;
                    break;
                case 2:
                    c = a.right - this.o();
                    break;
                default:
                    t1 = 0;
                    continue L0;
            }
            break;
        }
        return c;
    };
    PopupView.prototype.h = function (a, b) {
        var c;
        var t1 = b;
        L0: while (true) {
            switch (t1) {
                case 0:
                case 1:
                    c = a.bottom;
                    break;
                case 2:
                    c = a.top - this.n();
                    break;
                default:
                    t1 = 0;
                    continue L0;
            }
            break;
        }
        return c;
    };
    PopupView.prototype.ad = function (a, b, c) {
        var d = this.h(a, b);
        var e = this.g(a, c);
        this.aa(e, d);
        if (b == 2 || c == 2) {
            var f = 10;
            while (f > 0) {
                var g = this.h(a, b);
                var h = this.g(a, c);
                if (g == d && h == e) {
                    f = 0;
                    break;
                }
                d = g;
                e = h;
                this.aa(e, d);
                f--;
            }
        }
        return new Rect(0, e, d, this.o(), this.n());
    };
    PopupView.prototype.aa = function (a, b) {
        var c = stringFormat("{0}px", a);
        var d = stringFormat("{0}px", b);
        this.l.setStyleProperty("left", c);
        this.l.setStyleProperty("top", d);
    };
    PopupView.prototype.y = function (a) {
        var _this = this;
        if (a == null) {
            this.i = null;
            return;
        }
        this.i = a;
        var b = a.rootWrapper;
        this.t(b);
        this.i.getPortal(this.k, "ChildContent", function (c) {
            var comp_ = c.componentRef;
            _this.p = comp_;
        }, true);
    };
    PopupView.prototype.t = function (a) {
        this.m = a;
        this.x();
    };
    PopupView.prototype.u = function (a) {
        this.c = a;
    };
    PopupView.prototype.v = function () {
        if (this.f) {
            this.l.setStyleProperty("width", stringEmpty());
            this.l.setStyleProperty("height", stringEmpty());
            var a = this.o();
            var b = this.n();
            var c = stringFormat("{0}px", a);
            var d = stringFormat("{0}px", b);
            this.l.setStyleProperty("width", c);
            this.l.setStyleProperty("height", d);
            this.e = false;
        }
        else {
            this.e = true;
        }
    };
    PopupView.prototype.w = function () {
    };
    PopupView.$t = markType(PopupView, 'PopupView');
    return PopupView;
}(Base));
export { PopupView };
/**
 * @hidden
 */
var Popup = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(Popup, _super);
    function Popup() {
        var _this = _super.call(this) || this;
        _this.f = 0;
        _this.e = 0;
        _this.ay = null;
        _this.k = null;
        _this.l = null;
        _this.onClosed = null;
        _this.onPopup = null;
        _this.propertyChanged = null;
        _this.h = null;
        _this.q = -1;
        _this.p = Popup.s;
        _this.n = false;
        _this.ar = Popup.ax;
        _this.aq = Popup.aw;
        _this.ap = Popup.av;
        var a = _this.g();
        _this.h = a;
        a.u(_this);
        return _this;
    }
    Popup.prototype.ai = function (a, b, c) {
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
        this.ak(a, b, c);
    };
    Object.defineProperty(Popup.prototype, "t", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            var b = this.q;
            this.q = a;
            if (b != this.q) {
                this.ai("Elevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Popup.prototype, "r", {
        get: function () {
            return this.p;
        },
        set: function (a) {
            var b = this.p;
            this.p = a;
            if (b != this.p) {
                this.ai("ActualElevation", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Popup.prototype, "o", {
        get: function () {
            return this.n;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Popup.prototype, "au", {
        get: function () {
            return this.ar;
        },
        set: function (a) {
            var b = this.ar;
            this.ar = a;
            if (b != this.ar) {
                this.ai("ActualUmbraShadowColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Popup.prototype, "at", {
        get: function () {
            return this.aq;
        },
        set: function (a) {
            var b = this.aq;
            this.aq = a;
            if (b != this.aq) {
                this.ai("ActualPenumbraShadowColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Popup.prototype, "as", {
        get: function () {
            return this.ap;
        },
        set: function (a) {
            var b = this.ap;
            this.ap = a;
            if (b != this.ap) {
                this.ai("ActualAmbientShadowColor", b, a);
            }
        },
        enumerable: true,
        configurable: true
    });
    Popup.prototype.g = function () {
        return new PopupView();
    };
    Popup.prototype.ak = function (a, b, c) {
        switch (a) {
            case "IsShown":
                if (false == this.o) {
                    this.h.z();
                }
                break;
            case "Elevation":
                this.r = this.t == -1 ? Popup.s : this.t;
                break;
            case "ActualElevation":
            case "ActualUmbraShadowColor":
            case "ActualPenumbraShadowColor":
            case "ActualAmbientShadowColor":
                this.h.ac();
                break;
        }
    };
    Popup.prototype.ab = function () {
        if (this.m()) {
            if (null != this.l && this.l.playState == 1) {
                this.l.cancel();
            }
            if (null != this.k && this.k.playState == 1) {
                this.k.cancel();
            }
        }
    };
    Popup.prototype.i = function (a) {
        var b = this.h.n();
        if (b <= 0) {
            b = 500;
        }
        var c = a ? -b : 0;
        var d = a ? 0 : -b;
        if (this.f == 2) {
            c = 0;
            d = 0;
        }
        var e = a ? 0 : 1;
        var f = a ? 1 : 0;
        var g = a ? this.b() : this.a();
        var h = this.h.a(g);
        var i = new List$1(AnimationKeyFrameProperty.$, 0);
        var j = new List$1(AnimationKeyFrameProperty.$, 0);
        var k = new TranslateTransform();
        k.k = c;
        var l = new TranslateTransform();
        l.k = d;
        var m = new AnimationKeyFrameProperty(14, k);
        var n = new AnimationKeyFrameProperty(14, l);
        i.add(m);
        j.add(n);
        var o = new AnimationKeyFrameProperty(1, e);
        var p = new AnimationKeyFrameProperty(1, f);
        i.add(o);
        j.add(p);
        h.m.apply(h, tslib_1.__spread(i.toArray()));
        h.m.apply(h, tslib_1.__spread(j.toArray()));
        return KeyFrameAnimationFactory.f.c(h);
    };
    Popup.prototype.j = function (a) {
        var b = this.h.n();
        if (b <= 0) {
            b = 500;
        }
        var c = a ? 0 : b;
        var d = a ? b : 0;
        var e = a ? this.b() : this.a();
        var f = this.h.b(e);
        var g = new List$1(AnimationKeyFrameProperty.$, 0);
        var h = new List$1(AnimationKeyFrameProperty.$, 0);
        var i = new AnimationKeyFrameProperty(10, c);
        var j = new AnimationKeyFrameProperty(10, d);
        g.add(i);
        h.add(j);
        if (this.f == 2) {
            var k = a ? this.ay.bottom : this.ay.top;
            var l = a ? this.ay.top : this.ay.bottom;
            var m = new AnimationKeyFrameProperty(12, k);
            var n = new AnimationKeyFrameProperty(12, l);
            g.add(m);
            h.add(n);
        }
        f.m.apply(f, tslib_1.__spread(g.toArray()));
        f.m.apply(f, tslib_1.__spread(h.toArray()));
        return KeyFrameAnimationFactory.f.c(f);
    };
    Popup.prototype.a = function () {
        var a = new AnimationKeyFrameEffectTiming();
        a.g = 300;
        a.b = 3;
        return a;
    };
    Popup.prototype.b = function () {
        var a = new AnimationKeyFrameEffectTiming();
        a.g = 300;
        a.b = 3;
        return a;
    };
    Popup.prototype.ae = function () {
        this.h.s();
    };
    Popup.prototype.m = function () {
        if (null == this.l && null == this.k) {
            return false;
        }
        if (null != this.l && this.l.playState == 1) {
            return true;
        }
        if (null != this.k && this.k.playState == 1) {
            return true;
        }
        return false;
    };
    Popup.prototype.af = function () {
        this.h.v();
    };
    Popup.prototype.aj = function (a, b, c) {
        this.ay = this.h.ad(a, b, c);
        this.f = b;
        this.e = c;
    };
    Popup.prototype.am = function (a, b, c) {
        if (this.n) {
            this.n = false;
            this.ai("IsShown", true, this.n);
        }
        this.h.q();
        this.aj(a, b, c);
        this.an(true);
    };
    Popup.prototype.an = function (a) {
        var _this = this;
        this.ab();
        this.ae();
        var b = this.n;
        this.n = a;
        this.k = this.i(this.n);
        this.l = this.j(this.n);
        this.k.play();
        this.l.play();
        this.k.finished.f(function (c) { return _this.k.commitStyles(); });
        this.l.finished.f(function (c) {
            _this.l.commitStyles();
            _this.ai("IsShown", b, _this.n);
            if (_this.n) {
                if (_this.onPopup != null) {
                    _this.onPopup(_this, new OnPopupEventArgs());
                }
            }
            else {
                if (_this.onClosed != null) {
                    _this.onClosed(_this, new OnClosedEventArgs());
                }
            }
        });
    };
    Popup.prototype.appendPopupContent = function (a) {
        this.h.r(a);
    };
    Popup.prototype.ac = function () {
        if (!this.n) {
            return;
        }
        this.an(false);
    };
    Popup.prototype.destroy = function () {
        this.provideRenderer(null);
    };
    Popup.prototype.showRelativeToExclusionRect = function (a, b, c) {
        this.am(a, b, c);
    };
    Popup.prototype.ag = function (a) {
        this.ay = this.h.ad(a, this.f, this.e);
    };
    Popup.prototype.notifySizeChanged = function () {
    };
    Popup.prototype.provideRenderer = function (a) {
        this.h.y(a);
    };
    Popup.$t = markType(Popup, 'Popup', Base.$, [INotifyPropertyChanged_$type]);
    Popup.s = 2;
    Popup.ax = BrushUtil.g(66, 0, 0, 0);
    Popup.aw = BrushUtil.g(30, 0, 0, 0);
    Popup.av = BrushUtil.g(20, 0, 0, 0);
    return Popup;
}(Base));
export { Popup };
//# sourceMappingURL=PopupView_combined.js.map
